import React from "react";

// Subtle Aztec/Mexica geometric ornaments used as decorative accents.
// Inspired by xicalcoliuhqui (stepped fret), tonatiuh (sun stone), and Quetzalcoatl glyphs.

export const SunStone = ({ size = 600, className = "", style }) => (
  <svg width={size} height={size} viewBox="0 0 200 200" className={className} style={style} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <g stroke="currentColor" strokeWidth="0.5">
      <circle cx="100" cy="100" r="98" />
      <circle cx="100" cy="100" r="80" />
      <circle cx="100" cy="100" r="62" />
      <circle cx="100" cy="100" r="44" />
      <circle cx="100" cy="100" r="22" />
      {/* 16 spokes */}
      {Array.from({ length: 16 }).map((_, i) => {
        const a = (i * 360) / 16;
        return (
          <line
            key={i}
            x1="100"
            y1="100"
            x2={100 + 98 * Math.cos((a * Math.PI) / 180)}
            y2={100 + 98 * Math.sin((a * Math.PI) / 180)}
          />
        );
      })}
      {/* Stepped frets at cardinal points */}
      {[0, 90, 180, 270].map((deg) => (
        <g key={deg} transform={`rotate(${deg} 100 100) translate(100 12)`}>
          <path d="M-6 0 L-6 6 L-2 6 L-2 10 L2 10 L2 6 L6 6 L6 0 Z" fill="currentColor" fillOpacity="0.5" />
        </g>
      ))}
    </g>
  </svg>
);

export const StepGlyph = ({ size = 36, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 36 36" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <g stroke="currentColor" strokeWidth="1" fill="none">
      <path d="M2 34 L2 22 L10 22 L10 14 L18 14 L18 6 L26 6 L26 14 L34 14" />
      <circle cx="18" cy="2" r="1.2" fill="currentColor" />
    </g>
  </svg>
);

export const FretDivider = ({ width = 220, className = "" }) => (
  <svg width={width} height={14} viewBox="0 0 220 14" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <g stroke="currentColor" strokeWidth="1" fill="none">
      <line x1="0" y1="7" x2="80" y2="7" />
      <path d="M86 13 L86 7 L92 7 L92 1 L104 1 L104 7 L98 7 L98 13 Z" />
      <circle cx="110" cy="7" r="1.2" fill="currentColor" />
      <path d="M116 1 L116 7 L122 7 L122 13 L134 13 L134 7 L128 7 L128 1 Z" />
      <line x1="140" y1="7" x2="220" y2="7" />
    </g>
  </svg>
);

export const SerpentMark = ({ size = 80, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 80 80" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <g stroke="currentColor" strokeWidth="1" fill="none">
      <path d="M40 4 L72 28 L72 52 L40 76 L8 52 L8 28 Z" />
      <path d="M40 18 L60 32 L60 48 L40 62 L20 48 L20 32 Z" />
      <path d="M28 40 Q40 30 52 40 Q40 50 28 40 Z" fill="currentColor" fillOpacity="0.15" />
      <circle cx="34" cy="40" r="1.3" fill="currentColor" />
      <circle cx="46" cy="40" r="1.3" fill="currentColor" />
    </g>
  </svg>
);
